import { render, staticRenderFns } from "./newTextBoxPlus.vue?vue&type=template&id=47880032&scoped=true"
import script from "./newTextBoxPlus.vue?vue&type=script&lang=js"
export * from "./newTextBoxPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47880032",
  null
  
)

export default component.exports